import generateNamespacedActions from '@/state/generateNamespacedActions';
import * as handlers from './history.handlers';

import { HISTORY_NAMESPACE } from './history.constants';

export const historyActions = generateNamespacedActions(HISTORY_NAMESPACE, handlers);
